import { CatIconShop } from '@blocks-react/components/Icons/Shop';
import { CatIconBox } from '@blocks-react/components/Icons/Box';
import { CatIconManual } from '@blocks-react/components/Icons/Manual';
import { CatIconEditBox } from '@blocks-react/components/Icons/EditBox';
import { CatIconExternalLinkBox } from '@blocks-react/components/Icons/ExternalLinkBox';
import { CatIconSwap } from '@blocks-react/components/Icons/Swap';
import { CatIconCancel } from '@blocks-react/components/Icons/Cancel';
import { CatIconCheck } from '@blocks-react/components/Icons/Check';
import { CatIconTools } from '@blocks-react/components/Icons/Tools';
import { CatIconTaskComplete } from '@blocks-react/components/Icons/TaskComplete';
import { CatIconMenuDots } from '@blocks-react/components/Icons/MenuDots';
import { CatIconEngine } from '@blocks-react/components/Icons/Engine';
import { CatIconDashboard2 } from '@blocks-react/components/Icons/Dashboard2';
import { useCallback } from 'react';
import styles from './EquipmentActionIcon.module.scss';

export interface IconControlsProps {
  color?:
    | 'content-strong'
    | 'knockout'
    | 'knockout-brand'
    | 'information'
    | 'success'
    | 'warning'
    | 'error';
  iconTitle?: string;
  size?: 'sm' | 'lg' | 'xl';
}

export interface EquipmentActionIconProps {
  name: string;
  iconControls?: IconControlsProps;
  isIconExist?: boolean;
  children?: React.ReactNode;
}

export const EquipmentActionIcon = ({
  name,
  iconControls,
  isIconExist,
  children
}: Readonly<EquipmentActionIconProps>) => {
  const getIcon = useCallback(
    (name: string) => {
      switch (name) {
        case 'SHOP_PARTS':
          return <CatIconShop {...iconControls} />;
        case 'VIEW_DASHBOARD':
          return <CatIconDashboard2 {...iconControls} />
        case 'SHOP_PM_KITS':
          return <CatIconBox {...iconControls} />;
        case 'SIS_PART_LOOKUP':
          return <CatIconManual {...iconControls} />;
        case 'CAT_PARTS_DIAGRAM':
          return <CatIconEngine {...iconControls} />;
        case 'ENGINE_WARRANTY':
          return <CatIconTaskComplete {...iconControls} />;
        case 'CHANGE_EQUIPMENT':
          return <CatIconSwap {...iconControls} />;
        case 'REQUEST_SERVICE':
          return <CatIconTools {...iconControls} />;
        case 'SIS':
          return <CatIconExternalLinkBox {...iconControls} />;
        case 'EDIT':
        case 'ALP_MAINTENANCE_REPAIRS':
          return <CatIconBox {...iconControls} />;
        case 'MA_EDIT':
          return <CatIconEditBox {...iconControls} />;
        case 'SELECT_EQUIPMENT':
          return <CatIconCheck {...iconControls} />;
        case 'CLEAR_SELECTION':
          return <CatIconCancel {...iconControls} />;
        case 'MORE':
          return <CatIconMenuDots {...iconControls} />;
        default:
          return <></>;
      }
    },
    [iconControls]
  );

  return (
    <div className={styles['action-btn']}>
      {!isIconExist ? getIcon(name) : <>{children}</>}
    </div>
  );
};

export default EquipmentActionIcon;
